// import L from 'leaflet'
export class LiveTargetZxp {
  // constructor(options) {
  //   console.log(options)
  // }
}
